import { DEFAULT_PRODUCT_CONFIGURATION_ID, DEFAULT_NEW_EDITOR_PRODUCT_CONFIGURATION_ID } from '@env';
import { GROUP_CODES, PRODUCT_FAMILY_CODES } from 'src/constants/code.constants';
import { TProjectOptions } from './projectOptions.types';

export function getDefaultProjectOptions(isNewEditor = false): TProjectOptions {
  return {
    name: '',
    productConfigurationId: isNewEditor
      ? DEFAULT_NEW_EDITOR_PRODUCT_CONFIGURATION_ID
      : DEFAULT_PRODUCT_CONFIGURATION_ID,
    productFamily: isNewEditor ? PRODUCT_FAMILY_CODES.PRINT : PRODUCT_FAMILY_CODES.HOMEDECOR,
    groupCode: isNewEditor ? GROUP_CODES.PRINT_CLASSIC : undefined,
    projectId: undefined,
  };
}
